import React from 'react'
import { useDispatch , useSelector } from 'react-redux';
import {  Row, Col, Card, CardHeader, CardBody, Button } from 'reactstrap';
import { open_add_db_modal, open_add_db_modal_in_edit_mode } from '../../slices/Select_DB_Modal/reducer';
import Select_New_DB_Modal from '../../Components/Common/CustomModal/Select_New_DB_Modal';

const Database_In_Group = ({ DB_List }) => {
    const dispatch = useDispatch()
    const group_owner = useSelector((state)=>state.GroupOwner)
  return (
    <React.Fragment>
        <Select_New_DB_Modal  />
        <Card>
            <CardHeader className='no_border_bot'>
                <div className="d-flex align-items-center">
                    <div className="flex-shrink-0">
                        <h6 className="card-title mb-0">Database in this group</h6>
                    </div>
                    <div className="flex-grow-1 ms-2" style={{  textAlign: 'right'}}>
                        {/* <Add_User_To_Group_Modal/> */}
                       { group_owner.Group_Details.User_Role === 'Super User' && <Button onClick={()=>{
                            dispatch(open_add_db_modal())
                        }} color="secondary"> ADD NEW </Button>}
                       
                    </div>
                </div>                            
                
            </CardHeader>
            <CardBody className="db_in_gr">
                <div className="listjs-tabe" id="customerList_group">
                    <div className="table-responsive table-card mb-1">
                        <table className="table align-middle table-nowrap" id="customerTable">
                            <thead className="table-light">
                                <tr>
                                    {group_owner.Group_Details.User_Role === 'Super User' && <th style={{width: '52px',minWidth:'52px',paddingRight:'0px'}}>Action</th>}
                                    <th className="" data-sort="connection_name">Connection Name</th>
                                    <th className="" data-sort="db_type">DB Type</th>
                                    <th className="" data-sort="host">Host</th>
                                    <th className="" data-sort="port">Port</th>
                                </tr>
                            </thead>                                     
                            
                            <tbody className="list">
                                {
                                   DB_List?.map((ele,index) => {
                                    const {Connection_Name,
                                        Database_ID,
                                        Database_Name,
                                        Group_ID,
                                        IP,
                                        Last_Updated_By,
                                        Last_Updated_Date,
                                        Login_Name,
                                        Password,
                                        Port,
                                        Type,
                                    } = ele;
                                        return    <tr>
                                        {group_owner.Group_Details.User_Role === 'Super User' && <td onClick={()=>{
                            dispatch(open_add_db_modal_in_edit_mode(ele))
                        }} className="edit_view">                                                   
                                            
                                            <span  ><i className="mdi mdi-lead-pencil"></i></span>
                                        </td>}
                                        <td className="connection_name"><span>{Connection_Name}</span></td>
                                        <td className="db_type"><span>{Type}</span></td>
                                        <td className="host"><span>{IP}</span></td>
                                        <td className="port"><span>{Port}</span></td>
                                    </tr> 
                                   })
                                }
                            {/* <tr>
                                <td className="edit_view">                                                   
                                    
                                    <span><i className="mdi mdi-lead-pencil"></i></span>
                                </td>
                                <td className="connection_name"><span>LAM_TEST</span></td>
                                <td className="db_type"><span>MSSQL</span></td>
                                <td className="host"><span>148.123.12.43</span></td>
                                <td className="port"><span>1234</span></td>
                            </tr>  
                            <tr>
                                <td className="edit_view">                                                   
                                    
                                    <span><i className="mdi mdi-lead-pencil"></i></span>
                                </td>
                                <td className="connection_name"><span>LAM_TEST</span></td>
                                <td className="db_type"><span>MSSQL</span></td>
                                <td className="host"><span>148.123.12.43</span></td>
                                <td className="port"><span>1234</span></td>
                            </tr>  
                            <tr>
                                <td className="edit_view">                                                   
                                    
                                    <span><i className="mdi mdi-lead-pencil"></i></span>
                                </td>
                                <td className="connection_name"><span>LAM_TEST</span></td>
                                <td className="db_type"><span>MSSQL</span></td>
                                <td className="host"><span>148.123.12.43</span></td>
                                <td className="port"><span>1234</span></td>
                            </tr>  
                            <tr>
                                <td className="edit_view">                                                   
                                    
                                    <span><i className="mdi mdi-lead-pencil"></i></span>
                                </td>
                                <td className="connection_name"><span>LAM_TEST</span></td>
                                <td className="db_type"><span>MSSQL</span></td>
                                <td className="host"><span>148.123.12.43</span></td>
                                <td className="port"><span>1234</span></td>
                            </tr>   */}
                                                                            
                            </tbody>
                        </table>
                        
                    </div>
                    
                </div>
            </CardBody>
        </Card>
    </React.Fragment>
  )
}

export default Database_In_Group